export const CAMPAIGN_NODES = [
  {
    id: "level1",
    name: "Basic Words",
    type: "game",
    description: "Master typing short common words.",
    gameType: "game",
    levelId: "level1", 
    level: 1,
    backgroundId: "typingClass",
    rewards: {
      currency: 1000,
      premiumCurrency: 100
    }
  },
  {
    id: "level2",
    name: "Advanced Words",
    type: "game",
    description: "Challenge yourself with longer words.",
    gameType: "game",
    levelId: "level2",
    level: 2,
    backgroundId: "typingOffice",
    rewards: {
      currency: 2000,
      premiumCurrency: 200
    }
  },
  {
    id: "level3", 
    name: "Expert Words",
    type: "game",
    description: "Test your skills with complex words and phrases.",
    gameType: "game",
    levelId: "level3",
    level: 3,
    backgroundId: "typingArena",
    rewards: {
      currency: 3000,
      premiumCurrency: 300
    }
  }
];
